import React, { useEffect, useState } from 'react';
import AdminLayout from '../../../components/layout/AdminLayout';
import MemberForm from '../../../components/forms/MemberForm';
import { useMemberApi } from '../../../hooks/useMemberApi';
import { useNavigate, useParams } from 'react-router-dom';
import { MemberDTO } from '../../../services/apiClient';

const MemberEdit: React.FC = () => {
  const { getById, edit, isLoading } = useMemberApi();
  const [entityData, setEntityData] = useState<MemberDTO | null>(null);
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();

  const breadcrumbs = [
    { label: 'Admin', href: '#' },
    { label: 'Members', href: '/admin/members' },
    { label: 'Edit', href: '#' },
  ];

  useEffect(() => {
    const fetchEntityData = async () => {
      try {
        const response = await getById(id!);
        setEntityData(response?.data || null);
      } catch (error) {
        console.error('Error fetching Member data:', error);
      }
    };

    fetchEntityData();
  }, [id]);

  const handleSubmit = async (data: any) => {
    try {
      await edit(id!, data);
      navigate(-1);
    } catch (error) {
      console.error('Error updating Member:', error);
    }
  };

  return (
    <AdminLayout
      activeMenuItem="/admin/members"
      breadcrumbs={breadcrumbs}
      allowedRoles={['Admin']}
      requiredPermission='Manage.Members.Edit'
    >
        {entityData ? (
          <MemberForm
            initialValues={entityData}
            onSubmit={handleSubmit}
            onCancel={() => navigate(-1)}
          />
        ) : (
          <p>Loading...</p>
        )}
    </AdminLayout>
  );
};

export default MemberEdit;